<script>
import elcanoDefaultDomainIds from '../../variables/itineraryPrices/elcanoDefaultDomainIds';

export default {
  name: 'ItineraryEditInfo',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    salesCountryLoading: {
      type: Boolean,
      default: false,
    },
    tripThemesLoading: {
      type: Boolean,
      default: false,
    },
    isExtension: {
      type: Boolean,
      default: false,
    },
    salesCountries: {
      type: Array,
      default: () => [],
    },
    tripThemes: {
      type: Array,
      default: () => [],
    },
    tripCountries: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultDomainId: elcanoDefaultDomainIds.DK,
    };
  },
};
</script>

<template>
  <v-container class="ma-0 fluid">
    <v-card class="mb-2">
      <v-card-title>
        <div class="headline">Prices</div>
        <v-layout justify-end>
          <v-btn
            color="primary"
            @click="$router.push({
              name: 'ItineraryPrices',
              params: { domainId: defaultDomainId },
            })"
          >
            {{ $t('dialog.actions.edit') }}
          </v-btn>
        </v-layout>
      </v-card-title>
    </v-card>
    <v-card class="mb-2" v-if="tripCountries.length">
      <v-card-title class="pb-0">
        <div class="headline">{{ $t('itinerary.edit.general.tripCountries.label') }}</div>
      </v-card-title>
      <v-card-text>
          <p class="edit-label">{{ $t('itinerary.edit.general.tripCountries.description') }}</p>
          <v-flex>
            <v-chip
              v-for="(tripCountry, index) in tripCountries"
              :key="`trip-country__${index}`"
              color="teal"
              text-color="white"
            >
              <span class="px-2">{{ tripCountry.alias }}</span>
            </v-chip>
          </v-flex>
      </v-card-text>
    </v-card>
    <v-card class="mb-2">
      <v-card-title class="pb-0">
        <div class="headline">{{ $t('itinerary.edit.general.tripThemes.label') }}</div>
        <v-layout justify-end>
          <v-btn
            color="primary"
            @click="$emit('updateTripThemes')"
          >
            {{ $t('dialog.actions.edit') }}
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <p class="edit-label">{{ $t('itinerary.edit.general.tripThemes.description') }}</p>
        <v-flex v-if="tripThemes.length">
          <v-chip
            v-for="(tripTheme, index) in tripThemes"
            :key="`trip-theme__${index}`"
            color="teal"
            text-color="white"
            @click="$emit('updateTripThemes')"
          >
            <span class="px-2">{{ tripTheme.description }}</span>
          </v-chip>
        </v-flex>
        <p v-else-if="!tripThemesLoading">{{ $t('itinerary.edit.general.noContent') }}</p>
        <v-progress-circular
          v-else
          indeterminate
          color="primary"
        />
      </v-card-text>
    </v-card>
    <v-card v-if="isExtension">
      <v-card-title class="pb-0">
        <div class="headline">{{ $t('itinerary.edit.general.salesCountries.label') }}</div>
        <v-layout justify-end>
          <v-btn
            color="primary"
            @click="$emit('updateSalesCountries')"
          >
            {{ $t('dialog.actions.edit') }}
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <p class="edit-label">{{ $t('itinerary.edit.general.salesCountries.description') }}</p>
        <v-flex v-if="salesCountries.length">
          <v-chip
            v-for="(salesCountry, index) in salesCountries"
            :key="`sales-countries__${index}`"
            color="teal"
            text-color="white"
            @click="$emit('updateSalesCountries')"
          >
            <span class="px-2">{{ salesCountry.alias }}</span>
          </v-chip>
        </v-flex>
        <p v-else-if="!salesCountryLoading">{{ $t('itinerary.edit.general.noContent') }}</p>
        <v-progress-circular
          v-else
          indeterminate
          color="primary"
        />
      </v-card-text>
    </v-card>
    <v-card class="mb-2">
      <v-card-title>
        <div class="headline">Clone Itinerary</div>
        <v-layout justify-end>
          <v-btn
            color="warning"
            @click="$emit('cloneItinerary')"
          >
            CLONE
          </v-btn>
        </v-layout>
      </v-card-title>
    </v-card>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryEditInfo.vue